import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import EmailVerificationPrompt from './EmailVerificationPrompt';

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, loading, user } = useAuth();
    
    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                backgroundColor: '#212529',
                color: '#f0f0f0'
            }}>
                Loading...
            </div>
        );
    }
    
    if (!isAuthenticated) {
        return <Navigate to="/signin" replace />;
    }
    
    // Check if email is verified
    if (user && !user.emailVerified) {
        return <EmailVerificationPrompt />;
    }
    
    return children;
};

export default ProtectedRoute;

